import { connect } from 'react-redux';

import ScrollBar from './ScrollBar';

const mapStateToProps = (state) => ({
  pathname: state.routing.locationBeforeTransitions.pathname,
});

export default connect(mapStateToProps)(ScrollBar);
